<template>
  <div>
    <ColorPicker
      :color="color()"
      :id="id"
      default-format="rgb"
      :visible-formats="['rgb']"
      @color-change="update($event), test($event)"
      :key="keyCP"
      ><template #hue-range-input-label>
        <span class="sr-only">Hue</span>
      </template>

      <template #alpha-range-input-label>
        <span class="sr-only">Alpha</span>
      </template>

      <template #copy-button>
        <span class="sr-only">Copy color</span>

        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          viewBox="0 0 15 15"
        >
          <path
            d="M5 0v2H1v13h12v-3h-1v2H2V5h10v3h1V2H9V0zm1 1h2v2h3v1H3V3h3z"
            fill="currentColor"
          />

          <path
            d="M10 7v2h5v2h-5v2l-3-3zM3 6h5v1H3zm0 2h3v1H3zm0 2h3v1H3zm0 2h5v1H3z"
            fill="currentColor"
          />
        </svg>
      </template>
      <template #color-inputs>
        <span class="sr-only">Hex</span>
      </template>
    </ColorPicker>
    <div v-if="lastColor" class="d-inline-flex mt-1">
      Farbe übernehmen:
      <div
        class="d-inline-flex ms-1"
        :style="{
          background: lastColor,
          'border-radius': '5px',
          height: '20px',
          width: '20px',
          border: '1px solid grey',
          cursor: 'pointer',
        }"
        @click="updateCP"
      ></div>
    </div>
    <div :style="{ cursor: 'pointer' }" @click="saveColor">
      Farbe zwischenspeichern
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, ref } from "vue";

export default {
  props: {
    id: { type: String, required: true },
    pColor: { type: Object, required: false },
  },

  methods: {
    update(e) {
      this.$emit("update", e);
    },
  },
  setup(props, context) {
    const store = useStore();
    const lastColor = computed(() => store.getters.lastColor);
    const keyCP = ref(Math.random());
    const interC = ref("");
    function color() {
      if (
        props.pColor.type == "solid" &&
        props.pColor.color.length > 0 &&
        !props.pColor.color.includes("gradient")
      ) {
        return props.pColor.color;
      } else if (
        props.pColor.type == "gradient" &&
        props.pColor.color.length > 0
      ) {
        console.log(props.pColor);
        if (props.pColor.gradient == 1) {
          let start = props.pColor.color.indexOf("(");
          let end = props.pColor.color.indexOf(")");
          console.log(props.pColor.color.substring(start + 1, end));
          return props.pColor.color.substring(start + 1, end);
        } else if (props.pColor.gradient == 2) {
          let start = props.pColor.color.indexOf("),");
          let end = props.pColor.color.indexOf("))");
          console.log(props.pColor.color.substring(start + 1, end));
          return props.pColor.color.substring(start + 1, end);
        }
      } else {
        return "rgb(0, 72, 255)";
      }
    }
    function updateCP() {
      // color.value = lastColor.value;
      context.emit("update", lastColor.value);
      keyCP.value = Math.random();
    }
    function saveColor() {
      store.commit("setLastColor", interC.value);
    }
    function test(e) {
      interC.value = e.colors.hex;
    }
    return { lastColor, color, updateCP, keyCP, saveColor, test };
  },
};
</script>

<style lang="scss">
.sr-only {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  white-space: nowrap;
}
.vacp-copy-button {
  display: none;
}
.vacp-color-input-label-text {
  font-size: 17px;
}
.vacp-color-input-group .vacp-color-input-label:first-child input {
  border-color: red;
  border-width: 2px;
  font-size: 15px;
}
.vacp-color-input-group .vacp-color-input-label:nth-child(2) input {
  border-color: blue;
  border-width: 2px;
  font-size: 15px;
}
.vacp-color-input-group .vacp-color-input-label:nth-child(3) input {
  border-color: green;
  border-width: 2px;
  font-size: 15px;
}
</style>
